import { Navbar } from "./Navbar";

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="w-full h-full flex flex-col min-h-0 overflow-hidden">
      <Navbar />
      <div className="w-full h-full flex-1 min-h-0 overflow-auto">
        {children}
      </div>
    </div>
  );
};
